define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll'],
    function ($, transit, modernizr, container, preloader, router, scroll) {

        var module = (function () {

            var name = 'module-fan-touchpoint-type';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {

            }

            /* view */

            view.publicVars = {};

            view.privateVars = {

            };

            view.startup = function () {
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTypeStreamingHeaderMenuId, 'animate__faster animate__fadeIn', 'fan-touchpoint-type', {});
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTypeSocialDigitalHeaderMenuId, 'animate__faster animate__fadeIn', 'fan-touchpoint-type', {});
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTypeRetailHeaderMenuId, 'animate__faster animate__fadeIn', 'fan-touchpoint-type', {});
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTypeThemedEntertainmentHeaderMenuId, 'animate__faster animate__fadeIn', 'fan-touchpoint-type', {});
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTypeVirtualEntertainmentHeaderMenuId, 'animate__faster animate__fadeIn', 'fan-touchpoint-type', {});

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTypeStreamingAnimMainId, 'animate__faster animate__slideInLeft', 'fan-touchpoint-type', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTypeStramingAnimBoxId, 'animate__faster animate__slideInRight', 'fan-touchpoint-type', {});

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTypeSocialDigitalAnimMainId, 'animate__faster animate__slideInLeft', 'fan-touchpoint-type', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTypeSocialDigitalAnimBoxId, 'animate__faster animate__slideInRight', 'fan-touchpoint-type', {});

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTypeRetailAnimMainId, 'animate__faster animate__slideInLeft', 'fan-touchpoint-type', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTypeRetailAnimBoxId, 'animate__faster animate__slideInRight', 'fan-touchpoint-type', {});

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTypeThemedEntertainmentAnimMainId, 'animate__faster animate__slideInLeft', 'fan-touchpoint-type', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTypeThemedEntertainmentAnimBoxId, 'animate__faster animate__slideInRight', 'fan-touchpoint-type', {});

                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTypeVirtualEntertainmentAnimMainId, 'animate__faster animate__slideInLeft', 'fan-touchpoint-type', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.moduleFanTouchpointTypeVirtualEntertainmentAnimBoxId, 'animate__faster animate__slideInRight', 'fan-touchpoint-type', {});

            };

            view.bind = function () {

            };

            view.methods = {

            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();

        return module;


    });
